import Vue from 'vue'
import Vuex from 'vuex'

import alerts from 'Modules/Alert/resources/store/alerts'
import dashboard from 'Modules/Dashboard/resources/store/dashboard'
import acl from 'Modules/ACL/resources/store/acl'
import users from 'Modules/User/resources/store/users'
import auth from 'Modules/Auth/resources/store/auth'
import countries from 'Modules/Region/resources/store/countries'
import exchanges from 'Modules/Exchange/resources/store/exchanges'
import pairs from 'Modules/Pair/resources/store/pairs'
import operators from 'Modules/Operator/resources/store/operators'
import currencies from 'Modules/Currency/resources/store/currencies'
import rebitAccounts from 'Modules/RebitAccount/resources/store/rebit_accounts'
import exchangeRates from 'Modules/Ramp/resources/store/exchange_rates'
import paymentMethods from 'Modules/PaymentMethod/resources/store/payment_methods'
import helpCategories from 'Modules/Help/resources/store/categories'
import ramps from 'Modules/Ramp/resources/store/ramps'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default function (/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
      alerts,
      dashboard,
      acl,
      auth,
      users,
      countries,
      exchanges,
      pairs,
      operators,
      currencies,
      rebitAccounts,
      exchangeRates,
      paymentMethods,
      helpCategories,
      ramps
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: false // process.env.DEBUGGING
  })

  return Store
}
